import { removeAccents } from '@core/utils/case-conversions';

function folded(text: string): string {
  return removeAccents(text).toLowerCase();
}

/** Case- and accent-insensitive; every whitespace-separated term of `query` must be present. */
export function matchesSearch(text: string, query: string): boolean {
  const haystack = folded(text);
  return folded(query)
    .split(/\s+/)
    .filter((term) => term !== '')
    .every((term) => haystack.includes(term));
}
